// format MM-DD (mes-day)
const HOLIDAYS = [
  '01-01',
  '01-02',
  '01-03',
  '12-25',
  '01-04',
  '05-01',
  '05-01',
  '12-31',
  '07-26',
  '07-25',
  '07-27',
  '10-10'
];

const SECURITY_CONTAINER = {
  login: 'login',
  signup: 'signup',
  recovery: 'recovery',
};

const MIN_PASSWORD_SCORE_STRENGTH = 30;

export {
  HOLIDAYS,
  MIN_PASSWORD_SCORE_STRENGTH,
  SECURITY_CONTAINER};
